angular.module('bribac.services.authStorage', [
  'bribac.values'
])

  .factory('authStorage', function(
    $window,
    AUTH_LOCALSTORAGE_KEY,
    REMEMBER_ME_LOCALSTORAGE_KEY,
    state
  ) {
    var tabData = null
    var tabRemember = null

    return {

      set: function(data) {
        tabData = data
        $window.localStorage.setItem(AUTH_LOCALSTORAGE_KEY, angular.toJson(data))
      },

      setRememberMe: function (rememberMe) {
        tabRemember = rememberMe
        $window.localStorage.setItem(REMEMBER_ME_LOCALSTORAGE_KEY, rememberMe)
      },

      get: function() {
        return angular.fromJson($window.localStorage.getItem(AUTH_LOCALSTORAGE_KEY))
      },

      getRememberMe: function () {
        return $window.localStorage.getItem(REMEMBER_ME_LOCALSTORAGE_KEY)
      },

      // Enables the user to be authorized with different users in different
      // tabs within the same browser.
      //
      // On page reload the most recently set auth data will be restored from
      // localStorage.
      getTab: function() {
        return tabData
      },

      getTabRememberMe: function() {
        return tabRemember
      },

      clear: function() {
        tabData = null
        tabRemember = null
        $window.localStorage.removeItem(AUTH_LOCALSTORAGE_KEY)
        $window.localStorage.removeItem(REMEMBER_ME_LOCALSTORAGE_KEY)
        Object.keys(state).forEach(function(key) {
          delete state[key]
        })
      }

    }
  })
